module.exports = __webpack_public_path__ + "static/media/3-2.b566a6c7.png";